import { adjustmentSessionIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const findAdjustmentSessionBySource = {
  name: "findAdjustmentSessionBySource" as const,
  input: z.object({ sourceId: z.string() }),
  output: z.object({ sessionId: adjustmentSessionIdFormat.schema.nullable() }),
};
